import { render, staticRenderFns } from "./serviceStar.vue?vue&type=template&id=73bf597a&scoped=true&lang=html&"
import script from "./serviceStar.vue?vue&type=script&lang=js&"
export * from "./serviceStar.vue?vue&type=script&lang=js&"
import style0 from "./serviceStar.vue?vue&type=style&index=0&id=73bf597a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf597a",
  null
  
)

export default component.exports